import {
  AGENT_CANCEL_DOWNLOAD_BEGIN,
  AGENT_CANCEL_DOWNLOAD_SUCCESS,
  AGENT_CANCEL_DOWNLOAD_FAILURE,
  RESET_AGENT_CANCEL_DOWNLOAD_TYPE
} from "./types";
import { GENERIC_ERROR_MESSAGE } from "../../DownloadAndDelete/actions/types";
import API from "../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";

export const agentCancelDownload = () => async (dispatch, getState) => {
  dispatch({ type: AGENT_CANCEL_DOWNLOAD_BEGIN });

  const { uniqueTxnId } = getState().agentSelectedCustomerDownload;
  const { mtn } = getState().agentSelectedCustomer;
  try {
    const response = await API({
      method: "POST",
      url: ENDPOINTS.AGENT_CANCEL_DOWNLOAD,
      data: {
        uniqueTxnId,
        mtn
      }
    });

    if (response && response.status === "OK") {
      const elementsData = getState().agentCustomerHistory.elementsData.map(item => {
        if (item.uniqueTxnId === uniqueTxnId) {
          return {
            ...item,
            status: "CANCELLED"
          };
        }
        return item;
      });
      dispatch({
        type: AGENT_CANCEL_DOWNLOAD_SUCCESS,
        payload: { ...getState().agentCustomerHistory, elementsData }
      });
    }
  } catch (error) {
    dispatch({
      type: AGENT_CANCEL_DOWNLOAD_FAILURE,
      payload: error.response.description || GENERIC_ERROR_MESSAGE
    });
  }
};

export const resetCancelDownloadType = () => dispatch => {
  dispatch({
    type: RESET_AGENT_CANCEL_DOWNLOAD_TYPE
  });
};
